module.exports = __webpack_public_path__ + "img/ELA.1ab73386.svg";